// extracted by mini-css-extract-plugin
export default {"tx":"_47dd7c3a2b","line":"b103b1dd60"};